export const filter = {
    id: "",
    search: "",
    name: "",
    code: "",
    price: "",
    is_phy: "",
    discount_price: "",
    secondary_price: "",
    category_id: "",
    is_service: "",
    parent_id: "",
    created_at: "",
    updated_at: "",
};
